<kendo-grid
  #grid="kendoGrid"
  [data]="paging && gridView ? gridView : null"
  [kendoGridBinding]="!paging && !gridView ? gridView?.data : null"
  [pageSize]="paging ? state.take : 0"
  [skip]="state.skip"
  [sort]="state.sort"
  [pageable]="paging"
  [group]="state.group"
  [loading]="isRefreshing"
  (filterChange)="filterChanges($event)"
  [filter]="state.filter"
  [navigable]="true"
  [sortable]="{ allowUnsort: allowUnsort, mode: 'multiple' }"
  [filterable]="filtering"
  [columnMenu]="hasColumnMenu"
  [reorderable]="true"
  [groupable]="groupable === false ? false : { showFooter: true }"
  [style.height.%]="gridHeight"
  [resizable]="true"
  [selectable]="isMulti"
  [kendoGridSelectBy]="SelectById"
  [selectedKeys]="mySelection"
  (dataStateChange)="dataStateChange($event)"
  (selectedKeysChange)="onSelectedKeysChange($event)"
  (selectionChange)="onGridSelectionChange($event)"
  (edit)="editHandler($event)"
  (remove)="removeHandler($event)"
  (cellClick)="onRowClick($event)"
  (dblclick)="onDblClick($event)"
  (columnVisibilityChange)="onColumnVisibilityChange($event)">
  <ng-template kendoGridToolbarTemplate *ngIf="!hideToolber">
    <ssg-button
      *ngIf="isAdd"
      class="btnstyle"
      type="button"
      (click)="addHandler($event)"
      data-tooltip="top"
      tooltip="ایجاد رکورد جدید"
      icon="icon-add-o">
    </ssg-button>

    <ssg-button *ngIf="isHeaderSave" class="btnstyle" type="button" (click)="onHeaderSave()" data-tooltip="top" tooltip="ذخیره" icon="icon-save-F">
    </ssg-button>

    <ssg-button
      *ngIf="hasRefresh"
      class="btnstyle"
      (click)="refresh_Data()"
      [disabled]="isRefreshing"
      data-tooltip="top"
      tooltip="بازخوانی اطلاعات"
      icon="icon-refresh-o"></ssg-button>

    <ssg-button
      *ngIf="isCopy"
      class="btnstyle"
      type="button"
      (click)="copy()"
      [disabled]="isRefreshing"
      data-tooltip="top"
      tooltip="کپی‌سازی"
      icon="icon-content-copy">
    </ssg-button>
    <ng-container *ngIf="validActions && validActions.length > 0">
      <ng-container *ngFor="let action of validActions">
        <ssg-button
          *ngIf="!action.children"
          (click)="onToolbarItemClick(action)"
          class="btnstyle"
          data-tooltip="top"
          tooltip="{{ action.displayName }}"
          icon="{{ action.iconName }}">
        </ssg-button>

        <ssg-menu icon="icon-print-o" class="btnstyle" *ngIf="action.children">
          <ng-container class="menuitem">
            <div>
              <div *ngFor="let child of action.children" class="reportbtn" tooltip="{{ action.displayName }}">
                <button class="btn" (click)="onToolbarItemClick(child)">{{ child.displayName }}</button>
              </div>
            </div>
          </ng-container>
        </ssg-menu>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!noToolBar">
      <ssg-button
        *ngIf="!commonService.isMobileMode && hasAccessToExcel"
        icon="icon-exel"
        class="btnstyle"
        tooltip="خروجی اکسل"
        (click)="exportToExcel(grid)"
        data-tooltip="top">
      </ssg-button>

      <ssg-button (click)="clearFilter()" class="btnstyle" data-tooltip="top" tooltip="حذف فیلتر" icon="icon-filter-off-outline"></ssg-button>

      <ssg-button (click)="filtering = !filtering" class="btnstyle" data-tooltip="top" tooltip="فیلتر" icon="icon-filter_alt-o"></ssg-button>

      <ssg-button (click)="groupable = !groupable" class="btnstyle" data-tooltip="top" tooltip="دسته بندی" icon="icon-horizontal_split-o">
      </ssg-button>
    </ng-container>

    <ng-container *ngIf="!noToolBar || hasReport === true">
      <ssg-menu icon="icon-print-o" class="btnstyle" *ngIf="reportName != undefined && !commonService.isMobileMode" tooltip="چاپ">
        <ng-container class="menuitem">
          <div>
            <div *ngFor="let report of reportKinds" class="reportbtn">
              <button class="btn" (click)="changeReport(report.value)">{{ report.name }}</button>
            </div>
          </div>
        </ng-container>
      </ssg-menu>
    </ng-container>

    <ssg-button
      class="btnstyle"
      (click)="setDefaultColumnInfo()"
      [disabled]="isRefreshing"
      data-tooltip="top"
      tooltip="تنظیمات پیشفرض"
      icon="icon-settings-o1">
    </ssg-button>
    <ng-content select=".toolbar"> </ng-content>
  </ng-template>

  <kendo-grid-checkbox-column showSelectAll="true" [width]="60" [columnMenu]="false" minResizableWidth="60" *ngIf="isMulti">
    <ng-template kendoGridHeaderTemplate>
      <input
        class="k-checkbox"
        id="selectAllCheckboxId"
        kendoGridSelectAllCheckbox
        [state]="selectAllState"
        (selectAllChange)="onSelectAllChange($event)" />
      <label class="k-checkbox-label" for="selectAllCheckboxId"></label>
    </ng-template>
  </kendo-grid-checkbox-column>

  <kendo-grid-command-column *ngIf="isEdit || isDelete || isVisible" title="عملیات" [columnMenu]="false" [width]="65" minResizableWidth="60">
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <button *ngIf="isEdit" kendoGridEditCommand [primary]="true">
        <i class="edit icon-edit-o"> </i>
      </button>
      <button *ngIf="isVisible" kendoGridEditCommand>
        <i class="view icon-visibility-o"> </i>
      </button>
      <button *ngIf="isDelete" kendoGridRemoveCommand>
        <i class="delete icon-delete-o"> </i>
      </button>
    </ng-template>
  </kendo-grid-command-column>
  <kendo-grid-column
    *ngFor="let column of _columns"
    [sortable]="!unSortableFilterable.includes(column.name) && !unSortableFilterableAll"
    [filterable]="!unSortableFilterable.includes(column.name) && !unSortableFilterableAll"
    field="{{ column.name }}"
    title="{{ column.label }}"
    format="{{ column.format }}"
    [width]="column.columnWidth"
    [minResizableWidth]="column.columnWidth * 0.25"
    [hidden]="!column.listVisible || isGrouped(column.name)"
    filter="{{ column.textType == 'checkbox' ? 'boolean' : column.textType == 'number' ? 'numeric' : column.textType == 'date' ? 'date' : 'text' }}">
    <ng-template *ngIf="column.textType == 'checkbox'" kendoGridCellTemplate let-dataItem>
      <input type="checkbox" class="k-checkbox" [checked]="dataItem[column.name]" disabled />
    </ng-template>
    <ng-template *ngIf="column.inputMask" kendoGridCellTemplate let-dataItem>
      {{ getMaskedAmount(dataItem[column.name], column.inputMask) }}
    </ng-template>
    <ng-template *ngIf="hasAggregate(column.name)" kendoGridFooterTemplate>
      {{ getColumnAggregates(column.name) | number }}
    </ng-template>
    <ng-template kendoGridGroupHeaderTemplate let-value="value">
      {{ value }}
    </ng-template>
    <ng-template *ngIf="column.controlType == FormControlTypes.colorPicker" kendoGridCellTemplate let-dataItem>
      <span class="whole-cell" [class]="column.getBgColor(dataItem)">
        {{ dataItem[column.name] }}
      </span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-excel fileName="{{ apiName }}.xlsx" [fetchData]="allData"></kendo-grid-excel>
  <kendo-grid-pdf fileName="{{ apiName }}.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true" [landscape]="true"> </kendo-grid-pdf>

  <ng-template kendoPagerTemplate>
    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
    <kendo-pager-numeric-buttons [buttonCount]="buttonCount"></kendo-pager-numeric-buttons>
    <kendo-pager-next-buttons></kendo-pager-next-buttons>
    <kendo-pager-info></kendo-pager-info>
    <kendo-pager-page-sizes [pageSizes]="pageSizes"></kendo-pager-page-sizes>
  </ng-template>
</kendo-grid>
